
    // Highlight active navigation link
    document.addEventListener('DOMContentLoaded', () => {
      const currentPage = 'trading';
      const navLinks = document.querySelectorAll('[data-page]');
      
      navLinks.forEach(link => {
        if (link.getAttribute('data-page') === currentPage) {
          link.classList.remove('nav-link');
          link.classList.add('nav-link-active');
        }
      });
    });

    // Check if user is logged in and load profile
    const token = localStorage.getItem('token') || localStorage.getItem('authToken');
    if (!token) {
      window.location.href = '/login.html?redirect=/trading.html';
    } else {
      // Display user email
      fetch((window.location.hostname === 'localhost' ? 'http://localhost:3000' : 'https://coinlance.org') + '/api/v1/users/profile', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => {
        if (response.status === 401 || response.status === 404) {
          // Token invalid or user not found, redirect to login
          localStorage.removeItem('token');
          localStorage.removeItem('authToken');
          localStorage.removeItem('user');
          window.location.href = '/login.html?redirect=/trading.html';
          return null;
        }
        return response.json();
      })
      .then(data => {
        if (data && data.user && data.user.email) {
          document.getElementById('userEmailDisplay').textContent = data.user.email;
        }
      })
      .catch(error => console.error('Error loading profile:', error));
    }

    // Logout handler
    document.getElementById('logoutBtn')?.addEventListener('click', () => {
      localStorage.removeItem('token');
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      window.location.href = '/login.html';
    });
  